import allowFloat from 'helper/sanitizer/allow-float';
import allowInteger from 'helper/sanitizer/allow-integer';
import maxLength from 'helper/sanitizer/max-length';
import maxLengthWithDot from 'helper/sanitizer/max-length-with-dot';
import replaceCommasWithDots from 'helper/sanitizer/replace-commas-with-dots';
import stripChars from 'helper/sanitizer/strip-chars';
import stripHtml from 'helper/sanitizer/strip-html';
import stripInvalidDateChars from 'helper/sanitizer/strip-invalid-date-chars';
import stripInvalidIntegerChars from 'helper/sanitizer/strip-invalid-integer-chars';
import stripNumbers from 'helper/sanitizer/strip-numbers';
import stripSpecialChars from 'helper/sanitizer/strip-special-chars';

export type SanitizeFunctionType = (value: string) => string;

export default {
	maxLength,
	maxLengthWithDot,
	stripHtml,
	stripChars,
	stripNumbers,
	stripSpecialChars,
	stripInvalidDateChars,
	stripInvalidIntegerChars,
	replaceCommasWithDots,
	allowFloat,
	allowInteger,
};
